module.exports = __webpack_public_path__ + "img/sc-2-act.23434040.png";